<div class="flex h-full bg-grey-900 md:px-4 md:items-center md:justify-center">
  <div class="flex flex-col gap-6 bg-white p-10 md:max-w-md md:rounded-sm">
    <img width="100" height="100" ngSrc="assets/images/jcb-impact-logo.svg" alt="JCB Impact Logo">
    <h1 class="uppercase text-black text-[1.75rem] sm:text-[2rem]">{{ 'accessDenied.title' | transloco }}</h1>
    <p class="text-black text-base sm:text-lg">{{ 'accessDenied.body' | transloco }}</p>
    <a class="btn-primary text-center" [href]="jcbPortalUrl">{{ 'accessDenied.switchAccounts' | transloco }}</a>
  </div>
</div>
